import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const HookCreateForm = React.lazy(() => loadComponent('certification', 'HookCreateForm'))

export function CertificateHookCreateRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate('/certificate_automation')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/certificate_automation')
    }, [navigate])

    return (
        <RouteContainer>
            <HookCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
